/** Calcolo deadline SLA sommando ore lavorative a una data di riferimento. */
export function computeSlaDeadline(
  from: Date,
  slaHours: number,
): Date {
  const d = new Date(from.getTime());
  d.setHours(d.getHours() + slaHours);
  return d;
}

/** Ritorna true se `now` ha superato la deadline `slaDeadline`. */
export function isSlaBreached(slaDeadline: Date, now: Date = new Date()): boolean {
  return now.getTime() > slaDeadline.getTime();
}

/** Minuti rimanenti prima del breach SLA (negativo se già breach). */
export function slaMinutesRemaining(slaDeadline: Date, now: Date = new Date()): number {
  return Math.floor((slaDeadline.getTime() - now.getTime()) / 60000);
}
